import { cn } from "@/lib/utils";
import * as React from "react";

export default function Container({
  children,
  className,
  containerClassName,
  borderless = false,
  ...props
}: {
  children?: React.ReactNode;
  className?: string;
  containerClassName?: string;
  borderless?: boolean;
} & React.HTMLAttributes<HTMLElement>) {
  return (
    <section
      className={cn(
        "w-full",
        !borderless && "border-y border-neutral-100 dark:border-border",
        className,
      )}
      {...props}
    >
      <div
        aria-label="Container"
        className={cn(
          "mx-auto max-w-[80rem]",
          !borderless && "border-x border-neutral-100 dark:border-border",
          containerClassName,
        )}
      >
        {children}
      </div>
    </section>
  );
}
